import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route } from "react-router-dom";
import ScrollToTop from "./components/ScrollToTop";
import ErrorBoundary from "./components/ErrorBoundary";
import DashboardOverview from "./pages/dashboard-overview";
import DataTableView from "./pages/data-table-view";
import LoginScreen from "./pages/login-screen";
import FormEditor from "./pages/form-editor";
import NotFound from "./pages/NotFound";
import ProtectedRoute from "ProtectedRoute";
import Inspiration from "pages/inspiration";
import Analytics from "pages/analytics";
import LocationDevice from "pages/location-device";
import TrafficOverview from "pages/traffic-overview";
import UserBehaviour from "pages/user-behaviour";
import Acquisition from "pages/acquisition";
import Blogs from "pages/blogs";
import HomeInspiration from "pages/home-inspiration";
import GenerationFailedErrors from "pages/generationFailedErrors";
import EmailMarketing from "pages/email-marketing";
import AcademyInquiry from "pages/academy-inquiry";
import AcademyCoursePurchases from "pages/academy-course-purchases";
import ThirdPartyApiErrors from "pages/third-party-api-errors";

const Routes = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
        <ScrollToTop />
        <RouterRoutes>
          <Route path="/" element={<LoginScreen />} />

          {/* <Route
            path="/"
            element={
              <ProtectedRoute>
                <DashboardOverview />
              </ProtectedRoute>
            }
          /> */}
          <Route
            path="/dashboard-overview"
            element={
              <ProtectedRoute>
                <DashboardOverview />
              </ProtectedRoute>
            }
          />
          <Route
            path="/inspiration"
            element={
              <ProtectedRoute>
                <Inspiration />
              </ProtectedRoute>
            }
          />
          <Route
            path="/home-inspiration"
            element={
              <ProtectedRoute>
                <HomeInspiration />
              </ProtectedRoute>
            }
          />
          <Route
            path="/users"
            element={
              <ProtectedRoute>
                <DataTableView />
              </ProtectedRoute>
            }
          />
          <Route
            path="/blogs"
            element={
              <ProtectedRoute>
                <Blogs />
              </ProtectedRoute>
            }
          />
          <Route
            path="/email-marketing"
            element={
              <ProtectedRoute>
                <EmailMarketing />
              </ProtectedRoute>
            }
          />
          <Route
            path="/academy-inquiry"
            element={
              <ProtectedRoute>
                <AcademyInquiry />
              </ProtectedRoute>
            }
          />
          <Route
            path="/academy-course-purchases"
            element={
              <ProtectedRoute>
                <AcademyCoursePurchases />
              </ProtectedRoute>
            }
          />
          <Route
            path="/generationFailedErrors"
            element={
              <ProtectedRoute>
                <GenerationFailedErrors />
              </ProtectedRoute>
            }
          />
          <Route
            path="/third-party-api-errors"
            element={
              <ProtectedRoute>
                <ThirdPartyApiErrors />
              </ProtectedRoute>
            }
          />
          <Route
            path="/analytics"
            element={
              <ProtectedRoute>
                <Analytics />
              </ProtectedRoute>
            }
          />
          <Route
            path="/acquisition"
            element={
              <ProtectedRoute>
                <Acquisition />
              </ProtectedRoute>
            }
          />
          <Route
            path="/location-device"
            element={
              <ProtectedRoute>
                <LocationDevice />
              </ProtectedRoute>
            }
          />
          <Route
            path="/traffic-overview"
            element={
              <ProtectedRoute>
                <TrafficOverview />
              </ProtectedRoute>
            }
          />
          <Route
            path="/user-behaviour"
            element={
              <ProtectedRoute>
                <UserBehaviour />
              </ProtectedRoute>
            }
          />
          <Route
            path="/form-editor"
            element={
              <ProtectedRoute>
                <FormEditor />
              </ProtectedRoute>
            }
          />
          <Route path="*" element={<NotFound />} />
        </RouterRoutes>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;
